<ng-template>
    <div class="search-container position-relative">
        <input type="text" [(ngModel)]="searchValue" class="table-search rounded-pill pe-5" [placeholder]="placeholder" (keyup.enter)="emitSearch()" />
        <mat-icon class="search-icon position-absolute top-50 translate-middle-y" (click)="emitSearch()" style="cursor: pointer">search</mat-icon>
        <mat-icon *ngIf="searchValue" class="clear-icon position-absolute top-50 end-0 translate-middle-y me-3" (click)="clearSearch()" style="cursor: pointer">close</mat-icon>
    </div>
</ng-template>
